function ApiError(message, data) {
    let error = Error.call(this, message);

    this.name = "ApiError";
    this.message = error.message;
    this.stack = error.stack;
    this.data = data;
}

ApiError.prototype = Object.create(Error.prototype);
ApiError.prototype.constructor = ApiError;

export default ApiError;



/** WEBPACK FOOTER **
 ** ./app/utils/ApiError.js
 **/